import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addContact } from "../Store/ActionCreators/ContactActionCreator";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";


export default function ContactUser() {
  const [data, setData] = useState({
    name : "",
    mobile : "",
    subject : "",
    message:""
  })
  const dispatch = useDispatch()
  const navigate = useNavigate()
  function getData(e){
    const name = e.target.name
    const value = e.target.value
    setData((old)=>{
      return {
        ...old,
        [name] : value
      }
    })
  }
  function postData(e){
    e.preventDefault()
    const items = {
      name : data.name,
      mobile : data.mobile,
      subject : data.subject,
      message : data.message
    }
    dispatch(addContact(items))
    alert("Your Message Send Successfully !!! \n Our Team Contact You Shortly!!!")
    navigate("/contact")
  }
  return (
    <>
      {/* ================= HEADER ================= */}
      <Navbar/>
      <div className="container">
        <section className="contact-hero">
        <div className="container text-center">
          <h1>Contact Us</h1>
          <p>
            माँ शारदे डिजिटल सेवा केंद्र से संपर्क करें – हम आपकी सहायता के लिए
            हमेशा उपलब्ध हैं।
          </p>
        </div>
      </section>

      {/* ================= CONTACT SECTION ================= */}
      <section className="contact-section">
        <div className="container">
          <div className="row g-4 align-items-stretch">

            {/* LEFT INFO */}
            <div className="col-lg-5">
              <div className="contact-info-box">
                <h4>Maa Sharde Digital Seva Kendra</h4>

                <p>
                  भरोसेमंद डिजिटल और बैंकिंग सेवाओं के लिए हमसे संपर्क करें।
                </p>

                <ul>
                  <li>
                    <span>📍</span>
                    Gandhi Chowk, Chausa, Madhepura, Bihar
                  </li>
                  <li>
                    <span>📞</span>
                    +91 99551 82103
                  </li>
                  <li>
                    <span>📧</span>
                    msdskchousa@gmail.com
                  </li>
                  <li>
                    <span>⏰</span>
                    Mon – Sat : 8:00 AM – 8:00 PM
                  </li>
                </ul>

                <div className="social-links">
                  <a href="#">🌐</a>
                  <a href="#">📘</a>
                  <a href="#">📸</a>
                  <a href="#">▶️</a>
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="col-lg-7">
              <div className="contact-form-box">
                <h4>Send Us a Message</h4>

                <form onSubmit={postData}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your Name"
                        required
                        name="name"
                        onChange={getData}
                      />
                    </div>

                    <div className="col-md-6">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Mobile Number"
                        required
                        name="mobile"
                        onChange={getData}
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Subject"
                        required
                        name="subject"
                        onChange={getData}
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control"
                        rows="4"
                        placeholder="Write your message..."
                        required
                        name="message"
                        onChange={getData}
                      ></textarea>
                    </div>

                    <div className="col-12">
                      <button className="btn contact-btn" type="submit">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= MAP ================= */}
      <section className="contact-map mx-3 rounded">
        <iframe
          title="map"
          src="https://www.google.com/maps?q=Chausa%20Madhepura%20Bihar&output=embed"
          loading="lazy"
        ></iframe>
      </section>
      </div>
      <Footer/>
    </>
  );
}
